import get_debug from '@/utils/debug.js'
let site = 'https://agent.eingdong.com'
const debug_url = get_debug()
console.error(debug_url)
if (debug_url && process.env.NODE_ENV == 'development' && location.host != 'agent.eingdong.com') {
  site = debug_url
}
const app = {
  state: {
    site
  },
  mutations: {
    change_debug_url: (state, val) => {
      if (val) {
        state.site = val
      }
    }
  }
}

export default app
